import { useEffect, useState } from "react";
import TransferActivityPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/TransferActivityPage";
import ScheduledTransfersPage from "components/pages/TransferActivityPage/components/ScheduledTransfersPage";
import PendingApprovalPage from "components/pages/TransferActivityPage/components/PendingApprovalPage";
import { BCMSDefaultModel, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel } from "bcms-react";
import Classes, { TransferTransaction, User, UserAccount } from "model";
/**
 * @name CaptureTransferActivityMainPendingApprovalTabOpen
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Transfer Templates" (abi22).
 */
export default function CaptureTransferActivityMainPendingApprovalTabOpen(props) {
    const context = useBCMSContext();
    const model = useModel();
    BCMSRecord.globalControllerFor(Classes, context);
    const [ updateComp, setUpdateComp ] = useState(false);

    const addedTransfer = TransferTransaction.init({
        id: TransferTransaction.nextID(), 
        needsApproval: true, 
        from: "6", 
        to: "5", 
        numberOfApprovals: "0",
        numberOfApprovalsNeeded: "1",
        createdBy: UserAccount.init({ id: UserAccount.nextID() }),
        amount: "100"
    });

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update(["pendingApprovalTransfers"], [ addedTransfer ])
    .submit();

    // Initalize a new instance of BCMSStateManagerCRUD using the default page ui
    // updating hte content, scheduledTransfers and Accordion properties
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    // Sets the component to be used for the content
    .update([ "content" ], PendingApprovalPage)
    // Sets the tab to be selected
    .update([ "pendingApproval", "isActive" ], true)
    .submit();

        // We need to update "User" globally since pages like "TransferPage"
    // only modify the page, not shared content like the header.
    useEffect(() => {
        let user = model.user;
        const defaultUserAccount = BCMSDefaultModel.userAccount();
        
        user = { 
            ...user, 
            first: defaultUserAccount.first, 
            last: defaultUserAccount.last, 
            initials: defaultUserAccount.initials,
            allowTransferOnlyTemplates: "true"
        };

        BCMSRecord.batch([
            User.update(user)
        ], context, Classes);

        setUpdateComp(true);
    });

    // Return the TransferActivityPage passing the ui variable
    return <TransferActivityPage data={ data } ui={ ui } />
}